import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import hintImg from "../../assets/img/hint.svg";
import ReCAPTCHA from "react-google-recaptcha";
import Settings from "../../services/settings.service";
import FieldValidity from "../../services/fieldValidity.service";
import Countries from "../../services/countries.service";
import Phones from "google-libphonenumber";
import Storage from "../../services/storage.service";
import Advertisement from "../../services/advertisement.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import PhoneWrapper from "../shared/sharedFields/phoneWrapper";

export default function AdvertismentNumber({
  history
}) {
  const subscriptions = [];
  const prefix = "advertisement_";
  let error_prefix = "scr_3.3.3_";
  const phoneUtil = Phones.PhoneNumberUtil.getInstance();
  const [loading, setLoading] = useState(false);

  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [phoneCode] = useState({
    value: "SA",
    iso: 966,
    valid: true,
    touched: false,
  });
  const [phone, setPhone] = useState({
    value: "",
    validations: {
      required: true,
      contactNumber: true,
    },
    valid: false,
    touched: false,
    dependency: "selected_country_contact",
    error: "",
  });

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    Storage.set("act_step_detail", {
      step1: {
        status: "inProgress",
      },
      step2: {
        status: "notVisited",
      },
      step3: {
        status: "notVisited",
      }
    })

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updateCaptcha = (value) => {
    if (value) {
      setCaptchaChecked(true);
    } else {
      setCaptchaChecked(false);
    }
  };

  const updateContactField = (value) => {
    let validcontact = "";
    if (value.length > 6 && Settings.formats.phonenumber.test(value)) {
      let country = null;
      let dependency = phoneCode?.value;
      country = Countries.Countries[dependency];
      if (country && country.ISO_2Code) {
        let number = phoneUtil.parse(value, country.ISO_2Code);
        validcontact = phoneUtil.isValidNumber(number);
      } else {
        validcontact = Settings.formats.phonenumber.test(value);
      }
    } else {
      validcontact = false;
    }
    let errorMsg = "";
    if (!validcontact && !value) {
      errorMsg = translationKeys[error_prefix + "error_required_message"];
    } else if (!validcontact && value) {
      errorMsg = translationKeys[error_prefix + "error_number_invalid"];
    } else {
      errorMsg = "";
    }
    setPhone({
      ...phone,
      value: value,
      data_submition: true,
      valid: validcontact,
      touched: true,
      error: errorMsg,
    });
    if (validcontact) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };


  const handleSubmit = () => {
    setLoading(true);
    Storage.set("act_number", {
      number: phone.value,
    })
    let data = {
      number: phone.value,
      fraud_type: "RestrictCall"
    }
    Advertisement.getOTP(data)
      .then(response => {
        if (response && response?.data) {
          Storage.set("act_step_detail", {
            step1: {
              status: "isDone",
            },
            step2: {
              status: "inProgress",
            },
            step3: {
              status: "notVisited",
            }
          })
          history.push("/advertisement/otp/");

        }
      })
      .catch(error => {
        setLoading(false);
      });


  }
  return (<>
    {loading ? <SpinnerTimeLoader /> :
    <div className="stf-your-number-container">
      <StorefrontTitle
        title={translationKeys[prefix + "your_number"]}
        desc={translationKeys[prefix + "your_number_desc"]}
      />
      <div className="form-field-container">
        <div className="field-container">
          <label>{translationKeys[prefix + "phone_number"]}</label>
          <PhoneWrapper>
            <input
                type="number"
              className={
                "storefront-search-input " +
                (!phone.touched || (phone.touched && phone.valid)
                  ? ""
                  : "error") +
                (phone.value ? " filled" : "")
              }
              placeholder={translationKeys["stm_search_input_placeholder"]}
              name="contact_number"
              id="contact_number"
              value={phone.value}
              onChange={(event) => {
                if (FieldValidity.inputDigits(event, 10)) {
                  updateContactField(event.target.value, "form", "phone");
                }
              }}
            />
          </PhoneWrapper>
          {
            !phone.valid ? <span className="error-msg">{phone?.error}</span> : null
          }
          <div className="hint-section">
            <img src={hintImg} alt="Message" />
            <p>{translationKeys[prefix + "your_number_note"]}</p>
          </div>
        </div>
      </div>
      <div className="form-recaptcha">
        <ReCAPTCHA
          sitekey={Settings.get("google_recaptcha_site_key")}
          onChange={updateCaptcha}
        />
      </div>
      <button
        className={`continue-button ${
          !captchaChecked || !formValid ? "diabled" : ""
        }`}
        disabled={!captchaChecked || !formValid}
          onClick={() => { handleSubmit() }}
      >
        {translationKeys[prefix + "next"]}
      </button>
</div>}</>
  );
}
